class GroupBlock {
	static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-group'
	static SELECTOR_CLASS_ANIMATION = '.jtf__animation'
	static CLASS_NAME_ANIMATION_PREFIX = 'jtf__animation--'
	static ATTR_ANIMATION = 'data-animation'

	constructor( context ) {
		this.instance = context
		this.resizeHandler = this.onActionEvents.bind( this )
		this.scrollHandler = this.onActionEvents.bind( this )
		this.onActionEvents()
	}

	onActionEvents() {
		window.addEventListener( 'resize', this.resizeHandler )
		window.addEventListener( 'scroll', this.scrollHandler )
		this.checkAnimations()
	}

	checkAnimations() {
		const animations = document.querySelectorAll( GroupBlock.SELECTOR_CLASS_ANIMATION )
		animations.forEach( ( element ) => {
			if ( this.isInViewport( element ) ) {
				const animationType = element.getAttribute( GroupBlock.ATTR_ANIMATION )
				element.classList.add( GroupBlock.CLASS_NAME_ANIMATION_PREFIX + animationType )
			}
		} )
	}

	isInViewport( element ) {
		const elementTop = element.getBoundingClientRect().top + window.scrollY
		const viewportTop = window.scrollY
		const viewportBottom = viewportTop + window.innerHeight

		return elementTop < viewportBottom
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll( GroupBlock.SELECTOR_CLASS_BLOCK )
	blocks.forEach( ( block ) => {
		new GroupBlock( block )
	} )
} )